import { combineReducers } from "@reduxjs/toolkit";
import omit from "lodash/omit";

import { authReducer, userReducer, configReducer, filterReducer } from "@stadium/redux-utils/slices";

/*
  ================ REDUCERS ================
 */
import cart from "@slices/cart";
import country from "@slices/country";
import menu from "@slices/menu";
import order from "@slices/order";
import store from "@slices/store";

/*
  ================ REDUCERS ================
*/

const RESET_STATE_ACTION_TYPE = "reset";
const STORE_DEPENDENT_STATES = ["cart", "menu", "order", "store"]; //indicates which states will reset while traversing between shops

const appReducer = combineReducers({
  auth: authReducer,
  cart,
  config: configReducer,
  country,
  menu,
  order,
  store,
  filter: filterReducer,
  user: userReducer,
});

export const resetCache = () => {
  return { type: RESET_STATE_ACTION_TYPE };
};

const rootReducer = (state = {}, action) => {
  if (action.type === RESET_STATE_ACTION_TYPE) {
    state = omit(state, STORE_DEPENDENT_STATES);
  }
  return appReducer(state, action) || state;
};
export default rootReducer;
